import { combineReducers } from 'redux';
import user from './userReducer';
import slot from './adSlotReducer';
import rep from './repReducer';
import listing from './listingReducer';
import firm from './firmReducer';
import admin from './adminReducer';
import campaign from './campaignReducer';
import invoice from './invoiceReducer';
import photos from './photoReducer';
import content from './contentReducer';
import photoSets from './photoSetReducer';
import series from './seriesReducer';
import { connectRouter } from 'connected-react-router';

const createRootReducer = history => {
  return combineReducers({
    router: connectRouter(history),
    user,
    slot,
    rep,
    listing,
    firm,
    admin,
    campaign,
    invoice,
    photos,
    content,
    photoSets,
    series,
  });
};

export default createRootReducer;
